export default "__VITE_ASSET__7HWmkrD6__"